import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { SerieEstadistica } from '../entities/serie-estadistica';
import { Compromiso } from '../entities/Compromiso';
import { CompromisoSerie } from '../entities/CompromisoSerie';
import { DatosSerieResponse } from '../entities/DatosSerieResponse';
import { EncuestaSatisfaccion } from '../entities/EncuestaSatisfaccion';
import { SerieTematicaDisponible } from '../entities/serie-tematica-disponible';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class VisualizadorService {
  private urlBase = environment.API_REST_SERVICE_URL;//environment.API_REST_SERVICE_URL;// this.getUrlBase() 'http://localhost:8080'

  private headers = new HttpHeaders({
    'Content-type': 'application/json; charset=utf-8'
  });

  private urlServiceEstadisticas = this.urlBase + '/estadisticas-economicas-back/rest/estadisticaEconomicaRestService';

  private urlDataInformacionSerie: string = this.urlServiceEstadisticas + '/consultaInformacionSerie';
  private urlConsultaMenuXopcion: string = this.urlServiceEstadisticas + '/consultaMenuXopcion';
  private urlJsonConsultaArchivo: string = this.urlServiceEstadisticas + '/consultaArchivo';
  private urlJsonEncuestaSatisfaccion: string = this.urlServiceEstadisticas + '/generarEncuestaSatisfaccion';
  private urlDataInformacionBasicaSerie: string = this.urlServiceEstadisticas + '/consultaInformacionBasicaSerie';
  private urlInformacionSerieXTipoDato: string = this.urlServiceEstadisticas + '/consultaInformacionSerieXTipoDato';
  private urlInformacionSerieXTipoDatoXFechaDesde: string = this.urlServiceEstadisticas + '/consultaInformacionSerieXTipoDatoXFechaDesde';

  /***URLS PARA LA CONSULTA DE DATOS DEL CALENDARIO */
  private urlFestivos: string = this.urlServiceEstadisticas + '/buscarFestivosXAnnio';
  private urlCompromisos: string = this.urlServiceEstadisticas + '/buscarCompromisosXFecha';
  private urlCompromisosSeries: string = this.urlServiceEstadisticas + '/listarSeriesXCategoria';
  private urlCompromisosIndicador: string = this.urlServiceEstadisticas + '/buscarCompromisosXIndicador';
  private urlCompromisosXCategoriaXYearMonth: string = this.urlServiceEstadisticas + '/listarCompromisosXCategoriaYearMonth';

  /***URL PARA CONSULTAR EL CATÁLOGO DEL MENU */
  private urlConsultaMenuXId: string = this.urlServiceEstadisticas + '/consultaMenuXId';
  private urlConsultaParticipantesIbr: string = this.urlServiceEstadisticas + '/consultaParticipantesIbr';
  private urlJsonConsultaPropiedad: string = this.urlServiceEstadisticas + '/consultaPropiedad';
  private urlJsonConsultaFeErrata: string = this.urlServiceEstadisticas + '/consultaNotasFeErrata';
  private urlJsonConsultaSerieActiva: string = this.urlServiceEstadisticas + '/consultaSerieActiva';

  /***URL PARA CONSULTAR INTRADIA */
  private urlJsonMercadoCambiario: string = this.urlServiceEstadisticas + '/consultaMercadoCambiario';
  private urlJsonConsultaFestivoUSA: string = this.urlServiceEstadisticas + '/consultaFestivoUsaHoy';
  private urlJsonTablaMercadoCambiario: string = this.urlServiceEstadisticas + '/consultaTablaMercadoCambiario';

  private urlJsonInfoBoletin: string = this.urlServiceEstadisticas + '/consultaBoletines';

  private urlJsonInfoNotasFeErratas: string = this.urlServiceEstadisticas + '/consultaMetadataSerie';

  private urlJsonConsultaSerieArchivo: string = this.urlServiceEstadisticas + '/consultaSerieArchivo';

  private urlJsonConsultaMegaMenu: string = this.urlServiceEstadisticas + '/consultaMegaMenu';

  private urlJsonConsultaSerieTematicaDsiponible: string = this.urlServiceEstadisticas + '/consultaSeriesTematicasDisponibles';

  private urlCompartirOpinion: string = this.urlServiceEstadisticas + '/compartirOpinion';


  constructor(private http: HttpClient, private title: Title, private meta: Meta, @Inject(PLATFORM_ID) private platformId: Object) { }

  getInformacionSerie(idSerie: string): Observable<SerieEstadistica[]> {
    let urlWithParameters = this.urlDataInformacionSerie + '?idSerie=' + idSerie;
    return this.http.get<SerieEstadistica[]>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getInformacionMenu(idMenu: string): Observable<any[]> {
    let urlWithParameters = this.urlConsultaMenuXId + '?idMenu=' + idMenu;
    return this.http.get<SerieEstadistica[]>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getMenuXOpcion(opcion: string): Observable<Array<any>> {
    let urlWithParameters = this.urlConsultaMenuXopcion + '?opcion=' + opcion;
    return this.http.get<Array<any>>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  /*** SERVICIOS DE JHON JAIRO */
  getFestivosAnnio(annio: number): Observable<string[]> {
    let urlRest = this.urlFestivos + '?annio=' + annio;
    return this.http.get<string[]>(urlRest, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getCompromisosFecha(annio: number, mes: number, dia: number): Observable<Compromiso[]> {
    let urlRest = this.urlCompromisos + '?annio=' + annio + "&mes=" + mes + "&dia=" + dia;
    return this.http.get<Compromiso[]>(urlRest, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getCompromisosSeries(categoria: string): Observable<any[]> {
    let urlRest = this.urlCompromisosSeries + '?categoria=' + categoria;
    return this.http.get<any[]>(urlRest, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getCompromisosIndicador(fecha_ini: string, fecha_fin: string, indicador: string): Observable<CompromisoSerie[]> {
    let urlRest = this.urlCompromisosIndicador + '?fecha_ini=' + fecha_ini + "&fecha_fin=" + fecha_fin + "&indicador=" + indicador;
    return this.http.get<CompromisoSerie[]>(urlRest, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getCompromisosXCategoriaXAnnio(annio: number, mes: number): Observable<any[]> {
    let urlRest = this.urlCompromisosXCategoriaXYearMonth + '?annio=' + annio + '&mes=' + mes;
    return this.http.get<any[]>(urlRest, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getMenuXId(idMenu: string): Observable<DatosSerieResponse[]> {
    let urlRest = this.urlConsultaMenuXId + '?idMenu=' + idMenu;
    return this.http.get<DatosSerieResponse[]>(urlRest, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getParticipantesIbr(): Observable<Array<any>> {
    let urlWithParameters = this.urlConsultaParticipantesIbr;
    return this.http.get<Array<any>>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getMercadoCambiario(): Observable<any> {
    let urlWithParameters = this.urlJsonMercadoCambiario;
    return this.http.get<Array<any>>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getFestivoUSA(): Observable<any> {
    let urlWithParameters = this.urlJsonConsultaFestivoUSA;
    return this.http.get<any>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  consultaParametro(llave: string): Observable<any> {
    let urlWithParameters = this.urlJsonConsultaPropiedad + '?llave=' + llave;
    return this.http.get<any>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  consultaFeErratas(idSerie: string): Observable<any> {
    let urlWithParameters = this.urlJsonConsultaFeErrata + '?idSerie=' + idSerie;
    return this.http.get<any>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  consultaSerieActiva(idSerie: string): Observable<any> {
    let urlWithParameters = this.urlJsonConsultaSerieActiva + '?idSeries=' + idSerie;
    return this.http.get<any>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  consultaArchivo(archivo: string): Observable<any> {
    let urlWithParameters = this.urlJsonConsultaArchivo + '?archivo=' + archivo;
    return this.http.get(urlWithParameters, { responseType: 'blob' });
  }

  consultaBoletin(): Observable<any> {
    let urlWithParameters = this.urlJsonInfoBoletin;
    return this.http.get(urlWithParameters);
  }

  consultaJsonFile(archivo: string): Observable<any> {
    let urlWithParameters = archivo;
    return this.http.get<any>(urlWithParameters);
  }

  generarEncuestaSatisfaccion(encuesta: EncuestaSatisfaccion): Observable<any> {
    let urlWithParameters = this.urlJsonEncuestaSatisfaccion;
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    return this.http.post<any>(urlWithParameters, encuesta, { headers: headers }).pipe(retry(1), catchError(this.handleError));
  }

  getInformacionBasicaSerie(idSerie: string): Observable<SerieEstadistica[]> {
    let urlWithParameters = this.urlDataInformacionBasicaSerie + '?idSerie=' + idSerie;
    return this.http.get<SerieEstadistica[]>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  consultaInformacionBasicaSerie(idSerie: string): any {
    let urlWithParameters = this.urlDataInformacionBasicaSerie + '?idSerie=' + idSerie;
    let xhr = new XMLHttpRequest();
    xhr.open('GET', urlWithParameters, false);
    xhr.send(null);
    if (xhr.status === 200) {
      return JSON.parse(xhr.responseText);
    } else {
      throw new Error('Error al consultar la información basica de la serie.')
    }
  }

  getInformacionSerieXTipoDato(idSerie: string, tipoDato: number, cantDatos: number): Observable<SerieEstadistica[]> {
    let urlWithParameters = this.urlInformacionSerieXTipoDato + '?idSerie=' + idSerie + '&tipoDato=' + tipoDato + '&cantDatos=' + cantDatos;
    return this.http.get<SerieEstadistica[]>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getInformacionSerieXTipoDatoXFechaDesde(idSerie: string, tipoDato: number, cantDatos: number, frecuenciaDatos: string): Observable<SerieEstadistica[]> {
    let urlWithParameters = this.urlInformacionSerieXTipoDatoXFechaDesde + '?idSerie=' + idSerie + '&tipoDato=' + tipoDato + '&cantDatos=' + cantDatos + '&frecuenciaDatos=' + frecuenciaDatos;
    return this.http.get<SerieEstadistica[]>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getNotasFeErratas(idSerie: string): Observable<SerieEstadistica[]> {
    let urlWithParameters = this.urlJsonInfoNotasFeErratas + '?idSerie=' + idSerie;
    return this.http.get<SerieEstadistica[]>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getConsultaSerieArchivo(idSerie: string): Observable<SerieEstadistica[]> {
    let urlWithParameters = this.urlJsonConsultaSerieArchivo + '?idSerie=' + idSerie;
    return this.http.get<SerieEstadistica[]>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getMegaMenu(): Observable<string> {
    let urlWithParameters = this.urlJsonConsultaMegaMenu;
    return this.http.get(urlWithParameters, { responseType: 'text' });
  }

  getSerieTematicaDisponible(): Observable<SerieTematicaDisponible[]> {
    return this.http.get<SerieTematicaDisponible[]>(this.urlJsonConsultaSerieTematicaDsiponible)
  }

  compartirOpinion(opinion: string, correo: string): Observable<SerieEstadistica[]> {
    let urlWithParameters = this.urlCompartirOpinion + '?opinion=' + opinion + '&correo=' + correo;
    return this.http.get<any>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }

  getTablaMercadoCambiario(): Observable<any> {
    let urlWithParameters = this.urlJsonTablaMercadoCambiario;
    return this.http.get<any>(urlWithParameters, { headers: this.headers }).pipe(retry(1), catchError(this.handleError));
  }


  private handleError(error: HttpErrorResponse) {
    if (typeof window !== 'undefined' && error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(() => new Error('Ocurrió un error inesperado en el servicio, por favor intente de nuevo'));
  }


  public generaTagsHtmlSEO(titulo: string, descripcion: string, palabraClave: string, urlCanonica: string) {
    this.title.setTitle(titulo + ' | Banco de la República | Colombia');
    this.meta.updateTag({ name: 'description', content: descripcion });
    this.meta.updateTag({ name: 'author', content: 'Banco de la República de Colombia' });
    this.meta.updateTag({ name: 'keywords', content: palabraClave });
    this.updateCanonicalUrl(this.urlBase + urlCanonica);
  }

  private updateCanonicalUrl(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      const existLink: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
      if (existLink) {
        existLink.remove();
      }
      const link: HTMLLinkElement = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      document.head.appendChild(link);
    }
  }

  public getUrlBase(): string {
    var urlBase = '';
    if (isPlatformBrowser(this.platformId)) {
      urlBase = window.location.origin;
    }
    return urlBase;
  }

  public setWindowScroll(valX: number, valY: number) {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(valX, valY);
    }
  }

  public windowOpen(url: string, target: string) {
    if (isPlatformBrowser(this.platformId)) {
      window.open(url, target);
    }
  }

  public createObjectURL(objetoBlob: Blob) {
    var response: string = '';
    if (isPlatformBrowser(this.platformId)) {
      response = window.URL.createObjectURL(objetoBlob);
    }
    return response;
  }


}
